import React, { useEffect, useState } from "react";
import axios from "axios";
import { Monitor01, Phone01, Spinner, Tabs } from "@opendate-app/setlist";

import SampleDataPicker from "./SampleDataPicker";
import { useActionContext } from "./ActionContainer";
import { toastError } from "../../../../shared/toastHelper";
import EmailPreviewViewer from "../../shared/EmailPreviewViewer";
import { desktopFrameWidth } from "../../Broadcasts/emailPreviewWidth";

const containerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
  width: "100%",
  background: "var(--sl-border-secondary)",
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: 12,
  overflow: "hidden",
};

const previewColumnStyle = {
  flex: "2 1 420px",
  minWidth: 0,
  background: "var(--sl-bg-primary)",
  display: "flex",
  flexDirection: "column",
  fontSize: 14,
  color: "var(--sl-text-secondary)",
};

const detailRowStyle = {
  borderBottom: "1px solid var(--sl-border-secondary)",
  padding: "10px 16px",
};

export const htmlContentStyle = {
  border: "none",
  height: "100%",
  overflow: "scroll",
  width: "100%",
  background: "#fff",
};

const sampleDataPickerContainer = {
  flex: "1 1 260px",
  minWidth: 0,
  padding: 16,
  background: "var(--sl-bg-primary)",
};

const VIEWERS = [
  { value: "desktop", label: "Desktop", icon: Monitor01 },
  { value: "mobile", label: "Mobile", icon: Phone01 },
];

const EmailPreviewTab = () => {
  const {
    csrfToken,
    team,
    template,
    sampleData,
    parseLiquid,
    sampleFanId,
    sampleEventIds,
    subject,
    sendDomain,
    beefreeTemplate,
    campaign,
    venueOwnership,
  } = useActionContext();

  const [isLoading, setIsLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState("");
  const [viewer, setViewer] = useState("desktop");
  const [parsedSubject, setParsedSubject] = useState(subject);

  useEffect(() => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post("/teams/" + team.id + "/beefree_templates/" + beefreeTemplate.id + "/render_liquid_html", {
      beefree_template: {
        template: template,
        sample_data: sampleData,
        venue_ownership_id: venueOwnership?.id,
      },
    })
      .then(({ data }) => {
        setHtmlContent(data.parsedText);
        setIsLoading(false);
      })
      .catch(() => toastError("Could not fetch email preview, please try again"));

    parseLiquid(subject, sampleData, team.id, beefreeTemplate.id, csrfToken).then(({ parsedText }) => {
      setParsedSubject(parsedText);
    });
  }, [template, sampleData]);

  const sampleDataAvailable = !!sampleFanId && !!sampleEventIds.length;

  return (
    isLoading ? (
      <div className="d-flex justify-content-center" style={{ padding: 40 }}>
        <Spinner aria-label="Loading preview" />
      </div>
    ) : (
      <div style={containerStyle}>
        {sampleDataAvailable ? (
          <div style={sampleDataPickerContainer}>
            <SampleDataPicker />
          </div>
        ) : null}
        <div style={previewColumnStyle}>
          <div style={detailRowStyle}>
            <Tabs variant="button-border" size="sm" collapseBelow={0} items={VIEWERS} value={viewer} onChange={setViewer} />
          </div>
          <div style={detailRowStyle}><b>From: </b>{sendDomain?.name_with_address}</div>
          <div style={detailRowStyle}><b>To: </b>{sampleData.fan?.email}</div>
          <div style={detailRowStyle}><b>Subject: </b>{parsedSubject}</div>
          <EmailPreviewViewer htmlContent={htmlContent} frameWidth={desktopFrameWidth(template)} viewer={viewer} />
        </div>
      </div>
    )
  );
};

export default EmailPreviewTab;
